import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getPostData,
    getPostDataCancelToken,
    resetPublicView } from '../../../actions/publicView/view';
import MetaInfo from '../../../components/products/MetaInfo';
import LoginForm from '../Login/LoginForm';
import LoggedoutProductReportMeta from '../../../components/products/LoggedoutProductReportMeta';
import ProductReviewMeta from '../../../components/products/reviews/ProductReviewMeta';
import { miscLinks } from '../../../utils/internalLinks';
import SeoHeadMeta from '../../../components/misc/SeoHeadMeta';
import { decodeString } from '../../../utils/helper';

function ProductView(props) {
    const [productData, setProductData] = useState(null),
        [showLoginForm, setShowLoginForm] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
        document.querySelector('body').classList.add('white-bg');
        return () => {
            document.querySelector('body').classList.remove('white-bg');
        }
    }, []);
    useEffect(() => {
        props.getPostData('product', props.match.params.id)
        .then(val => {
            // redirect to 404 if not page
            if(!val) {
                props.history.replace(miscLinks.notFound);
            }
        });
        return function cleanup() {
            if (getPostDataCancelToken) getPostDataCancelToken();
            props.resetPublicView();
        }
    }, [props.match.params.id]);
    useEffect(() => {
        setProductData(props.publicView.viewData);
    }, [props.publicView.viewData]);
    if (!productData) return null;
    const reviewCount = productData.meta
        && productData.meta.overall_rating
        && productData.meta.overall_rating.count
        ? productData.meta.overall_rating.count
        : 0;
    return (<>
        { productData
            && productData.seoTags
            && productData.seoTags.title
            && <SeoHeadMeta title={productData.seoTags.title}>
                <title>{decodeString(productData.seoTags.title)}</title>
            </SeoHeadMeta>}
        <div className="container container--centered product__container">
            <MetaInfo meta={productData.meta}
                product={productData.product}
                publicClickAction={() => setShowLoginForm(true)}
                isPublic={true} />
            <LoggedoutProductReportMeta isPublic={true}
                meta={productData.meta}
                publicClickAction={() => setShowLoginForm(true)}
                productId={productData.product.id} />
            <ProductReviewMeta isPublic={true}
                publicUserReviews={productData.product.user_review}
                productId={productData.product.id}
                publicClickAction={() => setShowLoginForm(true)}
                reviewCount={reviewCount} />
        </div>
        { showLoginForm && <LoginForm shouldOnlyToggle={true}
            toggleLoginForm={() => setShowLoginForm(false)} /> }
    </>)
};

function mapStateToProps(state) {
    return {
        publicView: state.publicView
    }
}

const mapDispatchToProps = {
    getPostData,
    resetPublicView
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductView);